<template>
  <div class="px-2" >

    <h2>{{ title }}</h2>
    <div class="flex flex-wrap -mx-2">
      <div @click.prevent="select(carrier)" v-for="carrier in carriers" class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4">
        <div class="card-radios">
          <div class="card-title">{{ carrier.name }}</div>
          <div class="form-field horizontal">
            <label class="radio"> <span>{{ carrier.description }}
              <div >Kosten: {{ totalCarrierPrice(cart, carrier) }}</div>
              <div
                class="date-expected" v-if="false" >Lieferung vorr. am 00.00.2018</div></span>
              <input :checked="selected.uid === carrier.uid" type="radio" name="test">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'carriers',
    props: {
      selected: {
        type: Object,
        default: function () {
          return {}
        }
      },
      title: {
        type: String,
        default: 'Versandart'
      }
    },
    mixins: [formatting],
    data () {
      return {
        userInfo: {},
        showPaymentModal: false
      }
    },
    mounted () {
      this.getCarriers(this.cart.shop.uid)
    },
    methods: {
      ...mapActions([
        'getCarriers'
      ]),
      select (carrier) {
        this.$emit('selected', carrier)
      }
    },
    computed: {
      ...mapGetters({
        'carriers': 'checkout_get_carriers',
        'cart': 'checkout_get_cart'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shop/Carriers.vue